import { createContext, useContext } from "react";
import type { TranslationKey } from "./en";

export type Language = "en" | "sw";

export interface I18nContextValue {
  lang: Language;
  setLang: (lang: Language) => void;
  t: (key: TranslationKey, vars?: Record<string, string | number>) => string;
  /** For keys only known at runtime (server enums): falls back when missing. */
  tx: (key: string, fallback: string, vars?: Record<string, string | number>) => string;
}

export const I18nContext = createContext<I18nContextValue | undefined>(
  undefined,
);

export function useI18n(): I18nContextValue {
  const ctx = useContext(I18nContext);
  if (!ctx) throw new Error("useI18n must be used within an I18nProvider");
  return ctx;
}

export type { TranslationKey };
